import { createPortal } from 'react-dom';

import PrintIcon from '../../assets/svg/PrintIcon';
import { BasicModal, Button, CircularProgress, ModalHeader } from '../Shared';

import './brief.css';

// The report in a large window. While it is open, a copy waits outside the app's root for the browser's print.
export const BriefViewer = ({
  title,
  subtitle,
  notice,
  loadingMessage,
  errorMessage,
  onRetry,
  actions,
  isPrintDisabled,
  onClose,
  children,
}) => (
  <BasicModal open onClose={onClose} className="w-full max-w-[1000px]">
    <div className="h-[calc(100dvh-32px)] flex flex-col bg-white rounded-2xl shadow-[-40px_40px_80px_-8px_rgba(0,0,0,0.24)] overflow-hidden">
      <ModalHeader title={title} subtitle={subtitle} onClose={onClose} />
      {notice && (
        <div className="mx-5 mb-3 rounded-xl bg-rejected-500/20 p-3 text-base-1000 text-[14px]/[20px]">
          {notice}
        </div>
      )}
      <div className="flex-1 min-h-0 overflow-y-auto bg-[#dfe5ee] p-6 flex flex-col items-center gap-6">
        {loadingMessage && (
          <div className="m-auto flex flex-col items-center gap-3 text-base-800 text-[16px]/[24px] text-center">
            <CircularProgress size={40} />
            {loadingMessage}
          </div>
        )}
        {errorMessage && (
          <div className="m-auto flex flex-col items-center gap-3 text-base-1000 text-[16px]/[24px] text-center">
            {errorMessage}
            {onRetry && (
              <Button
                type="button"
                title="Try again"
                variant="blue"
                onClick={onRetry}
              />
            )}
          </div>
        )}
        {!loadingMessage && !errorMessage && children}
      </div>
      <div className="flex items-center justify-between gap-3 py-4 px-5">
        <button
          type="button"
          title="Print"
          aria-label="Print"
          disabled={isPrintDisabled}
          onClick={() => window.print()}
          className="w-10 h-10 flex items-center justify-center rounded-full text-brand-900 hover:bg-base-700 disabled:text-base-400 disabled:hover:bg-transparent"
        >
          <PrintIcon className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-3">{actions}</div>
      </div>
    </div>
    {!isPrintDisabled &&
      createPortal(<div id="brief-print-root">{children}</div>, document.body)}
  </BasicModal>
);
